// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ScrollArrows_arrow__pe1XJ","disabled":"ScrollArrows_disabled__qEk7t","hidden":"ScrollArrows_hidden___pAzX","no_arrow_class":"ScrollArrows_no_arrow_class__Quo26"};